import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component'

class ProductInventory extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.#onVariantUpdate));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, /** @type {EventListener} */ (this.#onVariantUpdate));
    this.#section = null;
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
